import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { useCreditSettings } from "@hooks/subscription/use-credit-settings";
import { useFetchCompanySubscriptions } from "@hooks/subscription/use-fetch-company-subscriptions";
import { useSubscriptionSettings } from "@hooks/subscription/use-subscription-settings";
import { useUsageMetrics } from "@hooks/subscription/use-usage-metrics";
import { useSeatSettings } from "@hooks/subscription/use-seat-settings";
import { Grid } from "@mui-wrapper";
import { BaseSettingsPage } from "@pages/settings/base-settings-page";
import { NoCredits } from "@pages/settings/subscription-settings/credits/no-credits";
import { allCreditSubscriptionsSelector, isFeatureAvailableInCompanySelector, isFetchingSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";

/**
 * Shows the subscription details
 */
export function SubscriptionSettings() {
  const $ = _c(16);
  const isLoading = useAppSelector(isFetchingSdbCompanySelector);
  const {
    subscriptionSectionProps
  } = useSubscriptionSettings();
  const {
    usageSectionProps
  } = useUsageMetrics();
  const {
    seatsSectionProps
  } = useSeatSettings();
  const {
    creditsSectionProps
  } = useCreditSettings();
  const creditSubscriptions = useAppSelector(allCreditSubscriptionsSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = isFeatureAvailableInCompanySelector("floorplan-generator");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isFloorplanGeneratorFeatureEnabled = useAppSelector(t0);
  const shouldShowNoTokensSection = isFloorplanGeneratorFeatureEnabled && creditSubscriptions.length === 0;
  useFetchCompanySubscriptions();
  let t1;
  if ($[1] !== creditsSectionProps || $[2] !== seatsSectionProps || $[3] !== subscriptionSectionProps || $[4] !== usageSectionProps) {
    t1 = [...subscriptionSectionProps, ...usageSectionProps, ...seatsSectionProps, ...creditsSectionProps];
    $[1] = creditsSectionProps;
    $[2] = seatsSectionProps;
    $[3] = subscriptionSectionProps;
    $[4] = usageSectionProps;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mt: "45px"
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isLoading || $[8] !== t1) {
    t3 = <BaseSettingsPage pageSectionProps={t1} isLoading={isLoading} isCompact={true} dataTestId="workspace-settings-subscription" customSx={t2} />;
    $[7] = isLoading;
    $[8] = t1;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isLoading || $[11] !== shouldShowNoTokensSection) {
    t4 = (isLoading || shouldShowNoTokensSection) && <Grid sx={{
      mt: "45px"
    }}>{isLoading ? <Skeleton variant="rectangular" sx={{
        width: "100%",
        height: "350px"
      }} /> : shouldShowNoTokensSection && <NoCredits />}</Grid>;
    $[10] = isLoading;
    $[11] = shouldShowNoTokensSection;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}